import { apiFetch } from './services/api';

// All reads/writes go through /api/ backend (tenant-scoped, authenticated)

export async function loadCollection(name, opts = {}) {
  let url = `/api/collection?name=${encodeURIComponent(name)}`;
  if (opts.createdAfter) url += `&createdAfter=${opts.createdAfter}`;
  const res = await apiFetch(url);
  return res.data || [];
}

export async function saveDoc(colName, item) {
  const id = String(item.id || item._fbId || Date.now());
  const { _fbId, ...data } = item;
  const payload = { ...data, id };
  await apiFetch(`/api/collection?name=${encodeURIComponent(colName)}`, {
    method: 'POST',
    body: payload,
  });
  return id;
}

export async function removeDoc(colName, id) {
  await apiFetch(`/api/collection?name=${encodeURIComponent(colName)}&id=${encodeURIComponent(id)}`, {
    method: 'DELETE',
  });
}
